<div class='width-1100'>

  <mat-card id='table-header'>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>settings_remote</mat-icon>
        <div>Push</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
        <a mat-button (click)="openDialog(null)" style='width:60px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card>
    <!-- TABLE -->

    <mat-table [dataSource]="dataSource">

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>settings_remote</mat-icon>
        </mat-cell>
      </ng-container>


      <!-- Target Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data/Hora </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.date_to_send.seconds*1000 | date: 'dd/MM/yyyy - HH:mm'
          }} </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef> Título </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.title }} </mat-cell>
      </ng-container>

      <!-- Target Column -->
      <ng-container matColumnDef="target">
        <mat-header-cell *matHeaderCellDef> Tipo </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.push_type }} </mat-cell>
      </ng-container>

      <!-- sent Column -->
      <ng-container matColumnDef="sent">
        <mat-header-cell *matHeaderCellDef> Enviado </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.sent'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.sent'>
            <img src='/assets/images/status/img_silver.png'>
          </span>
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class="icon-info">
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete'>delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

  <mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>

</div>